import { styled } from "@mui/material";
import { FC } from "react";

type Text = "center" | "left" | "right";
type ButtonType = "submit" | "reset" | "button";

interface ComponentProps {
  //extends React.ButtonHTMLAttributes<HTMLButtonElement>
  text?: string | JSX.Element;
  marginBottom?: string;
  type?: ButtonType;
  maxWidth?: string;
  minWidth?: string;
  textAlign?: Text;
  className?: string;
  bg?: string;
  color?: string;
  disabled?: boolean;
  marginTop?: string;
  onClick?: (e: any) => void;
  paddingBlock?: string;
  borderRadius?: string;
  border?: string;
}

export interface ButtonProps {
  marginBottom?: string;
  maxWidth?: string;
  minWidth?: string;
  textAlign?: Text;
  className?: string;
  bg?: string;
  color?: string;
  disabled?: boolean;
  marginTop?: string;
  paddingBlock?: string;
  borderRadius?: string;
  border?: string;
}

const Button: FC<ComponentProps> = ({
  text,
  marginBottom,
  marginTop,
  type,
  maxWidth,
  minWidth,
  textAlign,
  className,
  bg,
  color,
  disabled,
  onClick,
  paddingBlock,
  borderRadius,
  border,
}) => {
  return (
    <StyledButton
      bg={bg}
      marginBottom={marginBottom}
      marginTop={marginTop}
      color={color}
      className={`${className}`}
      disabled={disabled}
      onClick={onClick}
      textAlign={textAlign}
      maxWidth={maxWidth}
      type={type}
      paddingBlock={paddingBlock}
      borderRadius={borderRadius}
      border={border}
    >
      {text}
    </StyledButton>
  );
};
export default Button;

const StyledButton = styled("button")<ButtonProps>`
    position: relative;
    background: ${(props) =>
      props.bg ? props.bg : "var(--highlight-link-color)"};
    color: ${(props) => (props.color ? props.color : "var(--white-color)")};
    border-radius: ${(props) =>
      props.borderRadius ? props.borderRadius : "var(--font-s-4)"};
    padding-inline: 10px;
    padding-block:  ${(props) =>
      props.paddingBlock ? props.paddingBlock : "14px"};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: ${(props) => (props.minWidth ? props.minWidth : "0rem")};
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "174px")};
    width: 100%;
    margin-bottom: ${(props) => props.marginBottom || "0.8rem"};
    margin-block-start: ${(props) => props.marginTop || "0.8rem"};
    cursor: pointer;
    border: ${(props) => (props.border ? props.border : "0")};
    text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
    white-space: nowrap;
    transition: opacity 0.3s ease;

    @media (max-width: 587px) {
        margin-inline: auto;
        max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")} ;
    }

    &:focus {
        outline: none;
    }

    &:hover {
        background-color:${(props) => (props.bg ? props.bg : "#f1f1f1")};
        outline: 2px solid ${(props) =>
          props.bg ? props.bg : "var(--highlight-link-color)"};
        color:  color: ${(props) =>
          props.color ? props.color : "var(--text-dark)"};
    }

    & svg {
        margin-right: 0.93rem;
        min-width: 18px;
        min-height: 18px;
    }
    &:disabled {
        opacity: 0.8;
        background: #CBCED2;
        color: #FFFFFF;
        cursor: not-allowed;
    }
`;
